const s = { fill: "none", stroke: "currentColor", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" };

export const Sun = ({ className }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
    <circle cx="60" cy="60" r="26" {...s} />
    <path d="M50 56h0M70 56h0" {...s} strokeWidth="5" />
    <path d="M48 66c6 8 18 8 24 0" {...s} />
    <path d="M60 14v14M60 92v14M14 60h14M92 60h14M27 27l10 10M83 83l10 10M93 27L83 37M37 83L27 93" {...s} />
  </svg>
);

export const Plane = ({ className }) => (
  <svg viewBox="0 0 140 110" className={className} aria-hidden="true">
    <path d="M6 58L132 6 92 100 66 70z" {...s} />
    <path d="M132 6L66 70 60 96 52 62" {...s} />
  </svg>
);

export const Squiggle = ({ className }) => (
  <svg viewBox="0 0 220 60" className={className} aria-hidden="true">
    <path d="M6 40c14-40 30-40 24 0s20 20 26-10 26-20 22 10 22 22 30-6 26-22 24 4 22 18 24 10 34-10" {...s} />
  </svg>
);

export const Zigzag = ({ className }) => (
  <svg viewBox="0 0 200 50" className={className} aria-hidden="true">
    <path d="M4 40L24 10 44 40 64 10 84 40 104 10 124 40 144 10 164 40 184 10" {...s} />
  </svg>
);

export const Arrow = ({ className }) => (
  <svg viewBox="0 0 160 70" className={className} aria-hidden="true">
    <path d="M6 56c20-30 40-20 36-6s-22 4-10-20 70-24 110-6" {...s} />
    <path d="M130 12l14 12-16 8" {...s} />
  </svg>
);
